var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-0 p-0 custom"},[_c('LeavesVue',{attrs:{"firstTable":false,"tag":'h4'}}),_c('UpdateVue',{attrs:{"firstTable":false}}),_c('div',{staticClass:"bg-white shadow-sm rounded-3 px-3 pt-1"},[_c('WorklogVue',{attrs:{"firstTable":false,"tag":'h4'}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }